import { AnalyticTracker } from '@/shared/domain/models';
import { trackingEventConverter } from '@/shared/converters/TrackingEvent';

export const googleTagManager: AnalyticTracker = {
  sendEvent(payload, dataLayer) {
    const isDataLayerInstalled = Array.isArray(dataLayer);

    if (isDataLayerInstalled) {
      const { customProperties, category, action, label, ...other } = payload;

      const categoryEvent = category && {
        category: trackingEventConverter(category),
      };

      const actionEvent = action && {
        action: trackingEventConverter(action),
      };

      const labelEvent = label && {
        label: trackingEventConverter(label),
      };

      const event = {
        ...categoryEvent,
        ...actionEvent,
        ...labelEvent,
        ...other,
      };

      const gtmPayload = {
        ...event,
        ...customProperties,
        interaction: String(payload.interaction),
      };

      dataLayer.push(gtmPayload);
    }
  },
};
